import React from 'react';
import './styles/configuracionUsuario.css';
import { useState, useRef, useEffect } from "react";
import { FaUpload } from "react-icons/fa";
import Select from "react-select";
import { Link } from 'react-router-dom';
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography} from '@mui/material';
import { useSWRConfig } from "swr";
import Swal from 'sweetalert2';

const defaultImageBase64 = "data:image/png;base64,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";

const tematicas = [
    {value: "Programación", label: "Programación"},
    {value: "Programación web", label: "Programación web"},
    {value: "Programación de aplicaciones móviles", label: "Programación de aplicaciones móviles"},
    {value: "Lenguajes de programación", label: "Lenguajes de programación"},
    {value: "Java", label: "Java"},
    {value: "C++", label: "C++"},
    {value: "Python", label: "Python"},
    {value: "JavaScript", label: "JavaScript"},
    {value: "Php", label: "Php"},
    {value: "IA", label: "IA"},
    {value: "Emprendimiento", label: "Emprendimiento"},
    {value: "Comunicación", label: "Comunicación"},
    {value: "Ventas", label: "Ventas"},
    {value: "Negocios", label: "Negocios"},
    {value: "Gestión de Proyectos", label: "Gestión de Proyectos"},
    {value: "Recursos Humanos", label: "Recursos Humanos"},
    {value: "Comercio electrónico", label: "Comercio electrónico"},
    {value: "Contabilidad", label: "Contabilidad"},
    {value: "Finanzas", label: "Finanzas"},
    {value: "Economía", label: "Economía"},
    {value: "Inversión", label: "Inversión"},
    {value: "Informática", label: "Informática"},
    {value: "Ofimática", label: "Ofimática"},
    {value: "Hardware", label: "Hardware"},
    {value: "Desarrollo Personal", label: "Desarrollo Personal"},
    {value: "Diseño", label: "Diseño"},
    {value: "Diseño Gráfico", label: "Diseño Gráfico"},
    {value: "Diseño 3D y animación", label: "Diseño 3D y animación"},
    {value: "Diseño de moda", label: "Diseño de moda"},
    {value: "Diseño arquitectónico", label: "Diseño arquitectónico"},
    {value: "Diseño de interiores", label: "Diseño de interiores"},
    {value: "Marketing", label: "Marketing"},
    {value: "Marketing digital", label: "Marketing digital"},
    {value: "Marca personal", label: "Marca personal"},
    {value: "Arte y manualidades", label: "Arte y manualidades"},
    {value: "Pintura", label: "Pintura"},
    {value: "Dibujo", label: "Dibujo"},
    {value: "Cocina", label: "Cocina"},
    {value: "Fotografía y vídeo", label: "Fotografía y vídeo"},
    {value: "Nutrición", label: "Nutrición"},
    {value: "Deporte y fitness", label: "Deporte y fitness"},
    {value: "Música", label: "Música"},
    {value: "Ingeniería", label: "Ingeniería"},
    {value: "Humanidades", label: "Humanidades"},
    {value: "Filosofía", label: "Filosofía"},
    {value: "Lengua y literatura", label: "Lengua y literatura"},
    {value: "Matemáticas", label: "Matemáticas"},
    {value: "Ciencia", label: "Ciencia"},
    {value: "Física", label: "Física"},
    {value: "Química", label: "Química"},
    {value: "Biología", label: "Biología"},
    {value: "Geología", label: "Geología"},
    {value: "Ciencias Sociales", label: "Ciencias Sociales"},
    {value: "Psicología", label: "Psicología"},
    {value: "Historia", label: "Historia"},
    {value: "Historia del arte", label: "Historia del arte"},
    {value: "Geografía", label: "Geografía"},
    {value: "Idiomas", label: "Idiomas"},
    {value: "Idioma Inglés", label: "Idioma Inglés"},
    {value: "Idioma Español", label: "Idioma Español"},
    {value: "Idioma Francés", label: "Idioma Francés"},
    {value: "Idioma Alemán", label: "Idioma Alemán"},
    {value: "Idioma Ruso", label: "Idioma Ruso"},
    {value: "Idioma Chino", label: "Idioma Chino"},
    {value: "Idioma Árabe", label: "Idioma Árabe"},
    {value: "Idioma Japonés", label: "Idioma Japonés"},
    {value: "Formación de profesorado", label: "Formación de profesorado"},
    {value: "Preparación para examenes oficiales", label: "Preparación para examenes oficiales"},
];

const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%", // Ancho completo
      height: "50px", // Altura fija
      background: 'transparent',
      border: '2px solid var(--border-color)',
      borderRadius: '40px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(255, 255, 255, 0.5)' : 'none',
      fontSize: '16px',
      maxHeight: '70px', // Altura máxima del Select
      overflowY: 'auto', // Permite desplazamiento interno
      color: '#000',
      '&:hover': {
        borderColor: 'var(--border-color)',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000', // Cambiar el color del texto
    }),
    input: (provided) => ({
      ...provided,
      color: '#000', // Color del texto mientras se escribe
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#fff', // Color del placeholder
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',        // color de la flecha
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',  
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: 'var(--color-opcionseleccionada)', 
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'var(--textButtonHome)',                                  
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
      color: '#000',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.3)',
      },
    }),
   
};

function extraerExtDesdeDataURI(dataURI) {
  // dataURI = "data:image/png;base64,xxx…"
  if (typeof dataURI !== 'string') return null;
  const matches = dataURI.match(/^data:(image\/[a-zA-Z]+);base64,/);
  if (!matches) return null;
  const mime = matches[1];              // e.g. "image/png"
  const ext = mime.split("/")[1];       // e.g. "png"
  return ext;
}

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

//Validaciones asíncronas. Disponibilidad del Usuario nuevo
export async function disponibilidad(input){
//Hacer get con Usuario
try{
    const response = await fetch(`${baseUrl}/api/users/search/${input}`, {
        method: "GET",
        headers: {
        'Content-Type': 'application/json', 
        },
    });

    return !response.ok; 
    
} catch (error) {
    return false;
}  
}

//Componente para mostrar los datos de perfil de usuario
const DatosPerfil = ({ usuario }) => {
    

    return (
        <div className="datos_perfil">
            <h1>Datos del usuario {usuario.Usuario}</h1>
            <div className="perfilImagen">
                <img src={`data:image/png;base64,${usuario.ImagenPerfil}`} alt={`${usuario.Nombre } ${usuario.Apellidos}`} />
            </div>
            <div className='perfilInfo'>
                <h5><span className="label">Nombre:</span> <strong>{usuario.Nombre}</strong></h5>
                <h5><span className="label">Fecha de Nacimiento:</span> <strong>{new Date(usuario.FechaNacimiento).toLocaleDateString("es-ES", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric"
                            }).replace(/\//g, "-")}</strong>
                    
                </h5>
                <h5><span className="label">Apellidos:</span> <strong>{usuario.Apellidos}</strong></h5>
                <h5><span className="label">Fecha en la que se unió:</span> <strong>{new Date(usuario.FechaCreacion).toLocaleDateString("es-ES", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric"
                            }).replace(/\//g, "-")}</strong>
                
                </h5>
                <h5><span className="label">Nombre de usuario:</span> <strong>{usuario.Usuario}</strong></h5>
                <h5><span className="label">Tipo de cuenta:</span> <strong>{usuario.Tipo}</strong></h5>
                <h5><span className="label">Correo:</span> <strong>{usuario.Correo}</strong></h5>
                <h5><span className="label">Intereses:</span> <strong>{Array.isArray(usuario.Tematicas) ? usuario.Tematicas.join(', ') : ''}</strong></h5>
            </div>
        </div>
    );
};
  
const ConfigForm = ({ usuario, mutate }) => {

    //Seleccionar valores del formulario
    const [formData, setFormData] = useState({
      Usuario: usuario.Usuario,
      ContrasennaActual: "",
      ContrasennaNueva: "",
      ContrasennaNueva2: "",
      ImagenPerfil: usuario.ImagenPerfil,
      Tematicas: usuario.Tematicas,
    });
    // Para el botón de envío: si es Cliente, redirigir a /cliente, si no, a /tutor
    
    /////////////////Validaciones//////////////////////
    const usuarioRegExp = new RegExp(/^(?!admin$)(?!administrador$)[a-zA-Z0-9_]{4,15}$/i);
    const contrasennaRegExp = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/);
    
    const [usuarioVal, setUsuarioVal] = useState({
        hasError: false,
        disponible: true,
    });

    const [contrasennaActualVal, setContrasennaActualVal] = useState({
        hasError: false
    });
    const [contrasennaNuevaVal, setContrasennaNuevaVal] = useState({
        hasError: false
    });
    const [contrasennaNueva2Val, setContrasennaNueva2Val] = useState({
        hasError: false
    });


    //Select (multiples opciones)
    const [selectedOptions, setSelectedOptions] = useState(
        (usuario.Tematicas || []).map((tema) => ({ value: tema, label: tema }))
    );

    const handleSelect = (opts) => {
        setSelectedOptions(opts || []);
        setFormData((prev) => ({
            ...prev,
            Tematicas: (opts || []).map((o) => o.value),
        }));
    };

    //Manejador de cambios en campos de entrada
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value}));
    };
    
    //Manejar cambio de archivo de imagen
    const extOriginal = extraerExtDesdeDataURI(usuario.ImagenPerfil) || "png";
    const nombreInicial = `Imagen_${usuario.Usuario}.${extOriginal}`;

    const [image, setImage] = useState(usuario.ImagenPerfil);
    const [nombreImagen, setNombreImagen] = useState(nombreInicial);
    const fileInputRef = useRef(null); // Referencia al input file

    // Manejar el cambio de archivo
    const handleImageChange = (e) => {
      const file = e.target.files[0]; // Solo tomamos el primer archivo
      if (file) {
        const reader = new FileReader();
        setNombreImagen(file.name);
        reader.readAsDataURL(file); // Convertir imagen a Base64
        reader.onloadend = () => {
          /*const base64String = reader.result.split(',')[1]; // Extraer solo los datos base64
          setImage(base64String); // Almacenamos el archivo en el estado
          setFormData((prev) => ({ ...prev, ImagenPerfil: base64String }));*/
            const fullDataURI = reader.result; // ej. "data:image/png;base64,iVBORw0KGgoAAAANSU…"
            const mime = file.type;             // ej. "image/png"
            // Actualizamos el estado con prefijo completo:
            setImage(fullDataURI);
            setFormData((prev) => ({ ...prev, ImagenPerfil: fullDataURI }));
            // Y actualizamos el nombre con el nombre real del archivo:
            setNombreImagen(file.name);
        };
      }
    };

    //Eliminar imagen seleccionada
    const handleEliminarArchivo = () => {
      setNombreImagen("");
      setImage(null);
      setFormData((prev) => ({ ...prev, ImagenPerfil: "" }));
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Restablece el input file
      }
    };

     //Validaciones
    const handleBlur = async (e) => {
        const {name, value} = e.target;
        const trimmed = value.trim();

        //Error Usuario
        //Entre 4 y 15 caracteres.
        //Solo permite letras (A-Z, a-z), números (0-9) y guiones bajos _.
        //No puede contener espacios, guiones medios (-) ni otros símbolos.
        // No puede ser "Admin" ni "Administrador" (en mayúsculas o minúsculas).
        if(name === "Usuario"){
            const formatoIncorrecto = !usuarioRegExp.test(trimmed);
            setUsuarioVal(prev => ({ ...prev, hasError: formatoIncorrecto }));

            if (!formatoIncorrecto) {
                if (trimmed === usuario.Usuario) {
                    setUsuarioVal(prev => ({ ...prev, disponible: true }));
                } else {
                    const libre = await disponibilidad(trimmed);
                    setUsuarioVal(prev => ({ ...prev, disponible: libre }));
                }
            }
            else {
                setUsuarioVal((prev) => ({ ...prev, disponible: true }));
            }
        }
   
        //Error Contrasenna. 
        //Mínimo 6 caracteres.
        //Al menos una letra mayúscula, al menos una letra minúscula.
        //Al menos un número. 
        // Puede contener caracteres especiales, pero no son obligatorios.
        if(name === "ContrasennaActual"){
            const nueva = formData.ContrasennaNueva.trim();

            if (nueva !== "") {
                const contrasennaActualVacia = trimmed.length === 0;
                
                // Validamos si la actual está vacía
                setContrasennaActualVal({ hasError: contrasennaActualVacia });


                if (!contrasennaActualVacia) {
                    // Además, si hay contraseña nueva, comprobamos que no sea igual a la actual y cumpla el formato
                    const igualALaActual = nueva === trimmed;
                    const formatoValido = contrasennaRegExp.test(nueva);
                    setContrasennaNuevaVal((prev) => ({
                        ...prev,
                        hasError: !formatoValido || igualALaActual,
                    }));
                }
            } else{
                setContrasennaActualVal({ hasError: false });
            }   
        }

        // Validar contraseña nueva
        if (name === "ContrasennaNueva") {
            if(trimmed === ""){
                setContrasennaNuevaVal((prev) => ({ ...prev, hasError: false }));
            }
            else{
                const formatoValido = contrasennaRegExp.test(trimmed);
                const igualALaActual = trimmed === formData.ContrasennaActual.trim();
                setContrasennaNuevaVal((prev) => ({ ...prev, hasError: !formatoValido || igualALaActual }));
            }
            if (trimmed === "") {
                const coincide = formData.ContrasennaNueva2.trim() === trimmed;
                setContrasennaNueva2Val((prev) => ({ ...prev, hasError: !coincide }));
            }
        }

        // Validar confirmación de contraseña nueva
        if (name === "ContrasennaNueva2") {
            if(formData.ContrasennaNueva.trim() === ""){
                setContrasennaNueva2Val((prev) => ({ ...prev, hasError: false }));
            }
            else{
                const coincide = trimmed === formData.ContrasennaNueva.trim();
                setContrasennaNueva2Val((prev) => ({ ...prev, hasError: !coincide }));
            }
        } 
    }

    //Enviar datos a la API 
    const handleSubmit = async (e) => {
        e.preventDefault(); //Evitar recargar página

        //Si el usuario no ha seleccionado imagen, se utilizará una por defecto
        const finalImage = image ? image : defaultImageBase64;

        //Verificar que no existen errores:
        if (
            usuarioVal.hasError ||
            !usuarioVal.disponible ||
            contrasennaActualVal.hasError ||
            contrasennaNuevaVal.hasError ||
            contrasennaNueva2Val.hasError
        ){
           Swal.fire({
                icon: 'error',
                title: 'Formulario incorrecto',
                text: 'Por favor, corrija los errores antes de continuar.'
            });
            return;
        }

        const nuevaCont = formData.ContrasennaNueva.trim() !== "";
        const actualCont = formData.ContrasennaActual.trim() !== "";
        if(nuevaCont !== actualCont){
            Swal.fire({
                icon: 'error',
                title: 'Contraseñas incorrectas',
                text: 'Para cambiar la contraseña, debe indicar tanto la contraseña actual como la nueva.'
            });            
            return;
        }


        const dataToSend = {
            Usuario: formData.Usuario,
            ContrasennaActual: formData.ContrasennaActual,
            // Solo incluimos ContrasennaNueva si no está vacía
            ...(formData.ContrasennaNueva.trim() !== "" && {
                ContrasennaNueva: formData.ContrasennaNueva,
            }),
            ImagenPerfil: finalImage,
            Tematicas: formData.Tematicas,
        };

        try{
            const response = await fetch(`${baseUrl}/api/users/${usuario._id}`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json', // Asegúrate de indicar que estás enviando JSON
            },
            body: JSON.stringify(dataToSend),
            });

            // Verificar si la respuesta es exitosa
            if (!response.ok) {
                const errJSON = await response.json();
                console.error("Error devuelto por el backend:", errJSON.error);
                throw new Error("Error en la respuesta del servidor");
            }
            const usuarioActualizado = await response.json();
            localStorage.setItem("userLogueado", JSON.stringify(usuarioActualizado));

            await mutate(`${baseUrl}/api/users/tutor/${usuario._id}`);
            await mutate([`${baseUrl}/api/users?Tipo=Tutor`,
                    `${baseUrl}/api/clases/`,
                    `${baseUrl}/api/cursos/`,
                    `${baseUrl}/api/resennas/`
                ]
            );
            await mutate(`${baseUrl}/api/compras/search/usuario/${usuario._id}`);
            Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'Usuario modificado exitosamente',
                confirmButtonText: 'OK'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const redirectUrl = usuario.Tipo === "Cliente" ? "/cliente" : "/tutor";
                    window.location.href = redirectUrl;
                }
            });  
        } catch(error){
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Error con el servidor'
            }); 
        }
    }

    return (
        <div className='wrapperConfig'>
            <form onSubmit={handleSubmit}>
                <h1>Modificar datos del perfil</h1>
                <div className="input-boxC" style={{marginBottom: "-30px", marginLeft: "-5px"}}>
                    <input type="text" name="Usuario" placeholder="Nombre de usuario" value={formData.Usuario} onChange={handleChange} onBlur={handleBlur} aria-errormessage="UsuarioErrorID" aria-invalid={usuarioVal.hasError || !usuarioVal.disponible} required/>
                    <p
                        className="msgID"
                        id="UsuarioErrorID"
                        aria-live='assertive'
                        style={{ marginLeft: "30px", visibility: usuarioVal.hasError || !usuarioVal.disponible ? "visible" : "hidden" }}
                    >
                        {usuarioVal.hasError ? "Por favor, introduzca un usuario válido (4-15 caracteres, sin 'admin')" : "Nombre de usuario no disponible"}
                    </p>
                </div>
                <div className="input-tematicasC">
                    <label>Temáticas: </label>
                    <Select 
                        options={tematicas}
                        value={selectedOptions}
                        onChange={handleSelect}
                        isMulti={true}
                        styles={customStyles}
                        placeholder="Seleccione los temas que desee"
                    />
                </div>

                <div className="input-box-fileC">
                    <label htmlFor="input_file" className='input_label_fileC'>Subir imagen de perfil</label>
                    <input type="file" placeholder='Subir Imagen' id="input_file" accept='image/*' onChange={handleImageChange} ref={fileInputRef} hidden/>
                    <FaUpload  className="icons"/>

                    {nombreImagen && ( // Muestra el nombre del archivo si se seleccionó uno
                        <div style={{  display: "flex", flexDirection: "row", alignItems: "center", width:"100%", marginTop: "-20px"}}>
                            <p style={{ color: 'var(--text-principal)', marginLeft:"10px" }}>
                                Archivo seleccionado: {nombreImagen}
                            

                                <button onClick={handleEliminarArchivo} style={{ background: "transparent", color: 'var(--text-principal)', border: "none", cursor: "pointer", borderRadius: "5px", width:"10px", height:"10px", marginLeft:"10px"}}>
                                    X
                                </button>
                            </p>
                        </div>
                    )}
                </div>

                <details className="detallesContrasenna">
                    <summary style={{ cursor: "pointer"}}>
                        Modificar Contraseña
                    </summary>

                    <div className='contenedorContrasenna'>
                        <div className="input-boxC">
                            <input
                                type="password"
                                name="ContrasennaActual"
                                placeholder="Contraseña actual"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                aria-errormessage="ContrasennaActualErrorID"
                                aria-invalid={contrasennaActualVal.hasError}
                            />
                            <p
                                className="msgID"
                                id="ContrasennaActualErrorID"
                                aria-live="assertive"
                                style={{
                                    marginLeft: "30px",
                                    marginBottom: "10px",
                                    visibility: contrasennaActualVal.hasError 
                                    ? "visible"
                                    : "hidden"
                                }}
                            >
                                Debes ingresar su contraseña actual si desea modificar la contraseña, en caso contrario puede dejarla en blanco
                            </p>
                        </div>
                        <br/>
                        <div className="input-boxC">
                            <input type="password" name="ContrasennaNueva" placeholder='Contraseña nueva' onChange={handleChange} onBlur={handleBlur}
                                aria-errormessage="ContrasennaNuevaErrorID"
                                aria-invalid={contrasennaNuevaVal.hasError}
                            />
                            <p
                                className="msgID"
                                id="ContrasennaErrorID"
                                aria-live='assertive'
                                style={{ marginLeft: "30px", marginBottom: "20px", visibility: contrasennaNuevaVal.hasError ? "visible" : "hidden" }}
                            >
                                 {formData.ContrasennaNueva.trim() === formData.ContrasennaActual.trim()
                                    ? "La nueva contraseña no puede ser igual a la antigua."
                                    : "Por favor, introduzca una contraseña válida (mínimo 6 caracteres, al menos una mayúscula, una minúscula y un número)."}
                            </p>
                            <br/>
                        </div>
                        <br/>
                        <div className="input-boxC">
                            <input type="password" name="ContrasennaNueva2" placeholder='Confirmar contraseña nueva' onChange={handleChange} onBlur={handleBlur}
                                aria-errormessage="ContrasennaNueva2ErrorID"
                                aria-invalid={contrasennaNueva2Val.hasError}
                            />
                            <p
                                className="msgID"
                                id="ContrasennaNueva2ErrorID"
                                aria-live='assertive'
                                style={{marginLeft: "30px", marginBottom: "20px", visibility: contrasennaNueva2Val.hasError ? "visible" : "hidden" }}
                            >
                                Las contraseñas introducidas no coinciden 
                            </p>
                            <br/>
                        </div>
                        <br/>
                    </div>
                </details>

                <div>
                    <button type="submit">Guardar cambios</button>
                </div>
            </form> 
        </div>
    );
}

const PerfilUsuario = () => { 
    const { mutate } = useSWRConfig();

     const [usuario, setUsuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : {};
    });

    //Muestra u oculta primer modal (confirmar que desea eliminar cuenta)
    const [confirmarEliminacion, setconfirmarEliminacion] = useState(false); //Abrir modal de eliminacion

    //Muestra u oculta el segundo modal (mantener datos)
    const [confirmarMantenerDatos, setConfirmarMantenerDatos] = useState(false);

    //Eliminar Cuenta
    const handleEliminarCuenta = async (mantenerDatos) => {
        try {
            const respuesta = await fetch(`${baseUrl}/api/users/${usuario._id}?mantenerDatos=${mantenerDatos}`,
                { method: "DELETE" }
            );

            if(!respuesta.ok) throw new Error("Error al eliminar en el servidor");

            await mutate(`${baseUrl}/api/users/tutor/${usuario._id}`);
            await mutate([`${baseUrl}/api/users?Tipo=Tutor`,
                `${baseUrl}/api/clases/`,
                `${baseUrl}/api/cursos/`,
                `${baseUrl}/api/resennas/`
                ]
            );
            await mutate(`${baseUrl}/api/compras/search/usuario/${usuario._id}`);

            Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'Cuenta eliminada correctamente',
                confirmButtonText: 'OK'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    localStorage.removeItem("userLogueado");
                    window.location.href = "/";
                }
            });
      
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error con el servidor',
                text: 'Error al eliminar la cuenta de usuario'
            }); 
        } finally {
            setconfirmarEliminacion(false);
            setConfirmarMantenerDatos(false);
        }
    };

    const SolicitarEliminacionCuenta = () => {
        setconfirmarEliminacion(true);
    }

    const confirmarPrimerModal =  () => {
        setconfirmarEliminacion(false);
        setConfirmarMantenerDatos(true);
    }

    return (
        <div className='principal'>
            <div className='contenidoConfig'>
                <DatosPerfil usuario={usuario} />
                <details className='detalleFormulario'>
                    <summary style={{cursor: "pointer"}}>
                        Modificar datos de perfil
                    </summary>

                    <ConfigForm usuario={usuario} mutate={mutate} /> 
                </details>
        
                <div className='botonEliminar'>
                    <button onClick={SolicitarEliminacionCuenta}>Eliminar cuenta</button>
                </div>

                {/*Modal para eliminar cuenta de usuario. Pregunta si desea eliminar la cuenta */}
                <Dialog
                    open={confirmarEliminacion}
                    onClose={() => setconfirmarEliminacion(false)}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>
                        {`Eliminar cuenta de ${usuario.Usuario}`}
                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                            ¿Estás seguro de que deseas eliminar tu cuenta de usuario? Después no podrá deshacer el cambio
                        </Typography>
                    </DialogContent>
                        <DialogActions>
                            <Button sx={{textTransform: 'none'}} onClick={() => setconfirmarEliminacion(false)}>No</Button>
                            <Button sx={{textTransform: 'none'}} color="error" onClick={confirmarPrimerModal}>
                                Sí, eliminar
                            </Button>
                        </DialogActions>
                </Dialog>


                {/*Modal para eliminar cuenta de usuario. Pregunta sobre la eliminación de reseñas/mensajes*/}
                <Dialog
                    open={confirmarMantenerDatos}
                    onClose={() => setConfirmarMantenerDatos(false)}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>
                        {`Eliminación de datos asociados a ${usuario.Usuario}`}
                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                            {usuario.Tipo === 'Tutor' ? (
                                <>
                                    ¿Desea que se mantengan los mensajes que has enviado?
                                    <br />
                                    Tenga en cuenta que esos mensajes podrán seguir siendo vistos por otros usuarios.
                                    <br />
                                    - Si elige <strong>Mantener datos</strong>, tu cuenta se eliminará, pero los mensajes seguirán visibles por los usuarios a los que has enviado mensajes.
                                    <br />
                                    - Si eliges <strong>Eliminar todo</strong>, se borrará tu cuenta y también todos los mensajes que hayas enviado.
                                </>
                            ) : (
                                <>
                                    ¿Desea que se mantengan las reseñas y mensajes que has enviado?
                                    <br />
                                    Tenga en cuenta que las reseñas y mensajes pueden ser vistas por otros usuarios.
                                    <br />
                                    - Si elige <strong>Mantener datos</strong>, tu cuenta se eliminará, pero las reseñas y mensajes enviados seguirán visibles.
                                    <br />
                                    - Si eliges <strong>Eliminar todo</strong>, se borrará tu cuenta y también todas las reseñas y mensajes que hayas enviado.
                                </> 
                            )}
                            
                        </Typography>
                    </DialogContent>
                        <DialogActions>
                            <Button sx={{textTransform: 'none'}} onClick={() => handleEliminarCuenta(true)} color="primary">Sí, mantener datos</Button>
                            <Button sx={{textTransform: 'none'}} color="error" onClick={() => handleEliminarCuenta(false)}>
                                No, eliminar todo
                            </Button>
                            <Button sx={{textTransform: 'none'}} onClick={() => setConfirmarMantenerDatos(false)}>Cancelar eliminación</Button>
                        </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default PerfilUsuario;
